<template>
    <section class="top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'suppliers'}" :active="this.$router.currentRoute.name == 'suppliers'">Добавить задание</b-nav-item>
                <b-nav-item :to="{name: 'suppliersTaskList'}" :active="this.$router.currentRoute.name == 'suppliersTaskList'">Активные задания</b-nav-item>
                <b-nav-item :to="{name: 'suppliersArchiveList'}" :active="this.$router.currentRoute.name == 'suppliersArchiveList'">Архивные задания</b-nav-item>
                <b-nav-item :to="{name: 'suppliersKeys'}" :active="this.$router.currentRoute.name == 'suppliersKeys'">Список ключей</b-nav-item>
                <b-nav-item :to="{name: 'suppliersStopWords'}" :active="this.$router.currentRoute.name == 'suppliersStopWords'">Стоп-слова</b-nav-item>
                <b-nav-item :to="{name: 'suppliersExcludedSites'}" :active="this.$router.currentRoute.name == 'suppliersExcludedSites'">Исключенные сайты</b-nav-item>
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "TopMenu"
    }
</script>

<style scoped>
    .top-menu {
        margin-bottom: 20px;
    }
</style>